import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/providers/api.service';
import { Router } from '@angular/router';

import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list'

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-help-faq',
  templateUrl: './help-faq.component.html',
  styleUrls: ['./help-faq.component.scss']
})
export class HelpFAQComponent implements OnInit {
  searchText: string = '';
  faqsList: any[] = [];
  filteredFaqsList: any[] = [];

  constructor(public apiSrv: ApiService, public router: Router) { }

  ngOnInit() {
    this.getFAQ();
  }

  getFAQ() {
    let rte = `kb/faq`;
    this.apiSrv.get(rte).subscribe(res => {
      console.log(res);
      this.faqsList = res['data'];
      this.filteredFaqsList = this.faqsList; // Initialize filtered list
    });
  }

  onSearch() {
    this.filteredFaqsList = this.faqsList.map(group => ({
      ...group,
      questions: group.questions.filter(question =>
        question.fq_tx.toLowerCase().includes(this.searchText.toLowerCase())
      )
    })).filter(group => group.questions.length > 0);
  }
}
